const footer = {
    pages: 'Pages',
    newsletter: 'Stay in the know',
    siteBy: 'Website by',
}

export default footer
